import { GTMProvider } from '@elgorditosalsero/react-gtm-hook';
import { PropsWithChildren } from 'react';

import { useScript } from '@/hooks/use-script';

import { analyticsConfig } from '../configs/analytics.config';

interface AnalyticsProviderProps {}

export function AnalyticsProvider({ children }: PropsWithChildren<AnalyticsProviderProps>) {
  useScript(`https://cookiechimp.com/widget/${analyticsConfig.cookieChimp.id}.js`, 'cookiechimp');

  return <GTMProvider state={analyticsConfig.gtm}>{children}</GTMProvider>;
}
